import { ENDPOINTS } from "@/api/endpoints";
import { apiClient } from "@/lib/client";
import { DataSource, UploadedSessionData } from "@/types/common.types";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

interface UploadFileVariables {
  files: File[];
  jobName: string;
  dataSource: DataSource;
}

export type UploadFileResponse = UploadedSessionData;

const uploadFile = async ({
  files,
  jobName,
  dataSource,
}: UploadFileVariables): Promise<UploadFileResponse> => {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file, file.name));
  const response = await apiClient
    .post(ENDPOINTS.UPLOAD_FILE(jobName, dataSource), {
      body: formData,
      headers: {
        "Content-Type": "undefined",
      },
    })
    .json<UploadFileResponse>();

  return response;
};

export const useUploadFileMutation = (
  options?: UseMutationOptions<UploadFileResponse, Error, UploadFileVariables>
) => {
  return useMutation({
    mutationFn: uploadFile,
    ...options,
  });
};
